import type { DispoAlignment } from '../types'

// VICIdial dispo color buckets — not exhaustive; unknowns fall to default.
const DISPO_COLOR: Record<string, string> = {
  SALE: 'bg-emerald-600/20 text-emerald-300 border-emerald-700',
  XFER: 'bg-emerald-600/20 text-emerald-300 border-emerald-700',
  A: 'bg-amber-600/20 text-amber-300 border-amber-700',
  AM: 'bg-amber-600/20 text-amber-300 border-amber-700',
  AL: 'bg-amber-600/20 text-amber-300 border-amber-700',
  NI: 'bg-slate-700/30 text-slate-300 border-slate-600',
  NA: 'bg-slate-700/30 text-slate-300 border-slate-600',
  N: 'bg-slate-700/30 text-slate-300 border-slate-600',
  DNC: 'bg-red-600/20 text-red-300 border-red-700',
  B: 'bg-red-600/20 text-red-300 border-red-700',
  CALLBK: 'bg-sky-600/20 text-sky-300 border-sky-700',
  CB: 'bg-sky-600/20 text-sky-300 border-sky-700',
}

export function DispoBadge({
  dispo,
  size = 'sm',
}: {
  dispo: string
  size?: 'sm' | 'md'
}) {
  const color =
    DISPO_COLOR[dispo] || 'bg-slate-700/30 text-slate-300 border-slate-600'
  const cls =
    size === 'md' ? 'px-2 py-0.5 text-xs' : 'px-1.5 py-0.5 text-[10px]'
  return (
    <span
      className={`inline-flex items-center rounded border font-mono font-medium ${color} ${cls}`}
    >
      {dispo || '--'}
    </span>
  )
}

export function DispoMismatchBadge({
  alignment,
}: {
  alignment: DispoAlignment | null | undefined
}) {
  if (!alignment) return null
  if (alignment.match) {
    return (
      <span
        className="inline-flex items-center rounded border border-emerald-700 bg-emerald-600/20 px-1.5 py-0.5 text-[10px] font-medium text-emerald-300"
        title="VICIdial dispo matches rubric prediction"
      >
        match
      </span>
    )
  }
  return (
    <span
      className="inline-flex items-center rounded border border-red-700 bg-red-600/20 px-1.5 py-0.5 text-[10px] font-medium text-red-300"
      title={`Rubric predicted ${alignment.predicted}`}
    >
      mismatch
    </span>
  )
}
